import * as React from 'react';
import classNames from 'classnames';
import { UIText1, UIText2, ArticleHeading2 } from '@cian/ui-kit';

import { formatMoney } from '../../../../../../../../utils/string';
import * as styles from './DefaultPublication.css';

interface IProps {
  selected: boolean;
  isMobile: boolean;
  handleClick(): void;
  price: number;
}

export const DefaultPublication = ({ selected, isMobile, handleClick, price }: IProps) => (
  <div
    className={classNames(styles['wrapper'], selected && styles['selected'], isMobile && styles['mobile'])}
    onClick={handleClick}
  >
    <div className={styles['text']}>
      <div className={styles['title']}>
        <UIText1 fontWeight="bold">Одно объявление</UIText1>
      </div>

      <UIText2>Опубликуйте сейчас по обычной цене</UIText2>
    </div>

    <div>
      <ArticleHeading2>{formatMoney(price)}</ArticleHeading2>
    </div>
  </div>
);
